import { toast } from 'react-toastify';
import { quotesAPI } from 'services/swagger-api';
import { ContractualizationSyncActions } from '../contexts/actions/types';

interface SignatureRequestParams {
  quoteId: string;
  fullName: string;
  email: string;
  hasGroupContract: boolean;
  bankAccountId?: string;
}

export const sendContractSignatureRequest = async (
  params: SignatureRequestParams,
  actions: ContractualizationSyncActions
): Promise<{ success: boolean }> => {
  const { quoteId, fullName, email, hasGroupContract, bankAccountId } = params;

  try {
    actions.setIsSendingContract(true);
    actions.setError(null);

    if (!quoteId) {
      toast.error('ID de devis manquant');
      actions.setError('ID de devis manquant');
      return { success: false };
    }

    const result = await quotesAPI.sendContract({
      sendContractCommandDto: {
        quoteId,
        fullName,
        email,
        forced: false,
        bankAccountId
      }
    });

    actions.addContractDocument(hasGroupContract);

    return { success: result.isSuccess ?? false };
  } catch (error) {
    console.error('Erreur lors de la soumission:', error);
    toast.error("Une erreur s'est produite pendant l'envoi de la demande");
    actions.setError("Erreur lors de l'envoi de la demande de signature");
    return { success: false };
  } finally {
    actions.setIsSendingContract(false);
  }
};
